import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { baseAxios } from '../utils/axiosConfig';
import './AdminLogin.css';
import { checkAdminStatus } from '../utils/adminAuth';
import { useFlashMessage } from './FlashMessage';
import { getErrorMessage } from '../utils/errorMessages';
import PasswordInput from './ui/PasswordInput';

function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { showSuccess, showError } = useFlashMessage();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        
        try {
            // Login using the token endpoint which now sets HttpOnly cookies
            await baseAxios.post('/api/token/', {
                email: email,
                password: password
            });

            // Check admin status using the cookie-based authentication
            try {
                const adminResponse = await baseAxios.get('/api/authentication/check-admin/', {
                    withCredentials: true
                });
                
                if (adminResponse.data.is_admin) {
                    localStorage.setItem('isAdminLoggedIn', 'true');
                    showSuccess('Admin login successful! Redirecting...');
                    
                    // Small delay to show success message before redirect
                    setTimeout(() => {
                        history.push('/settings/hms-admin');
                    }, 1000);
                } else {
                    const errorMsg = 'Access denied. Superuser privileges required.';
                    setError(errorMsg);
                    showError(errorMsg);
                    localStorage.removeItem('isAdminLoggedIn');
                }
            } catch (adminError) {
                console.error('Admin check error:', adminError);
                const errorMsg = 'Access denied. Superuser privileges required.';
                setError(errorMsg);
                showError(errorMsg);
                localStorage.removeItem('isAdminLoggedIn');
            }
        } catch (error) {
            console.error('Login error:', error);
            const errorMsg = getErrorMessage(error, 'Login failed. Please check your credentials and try again.');
            setError(errorMsg);
            showError(errorMsg);
            localStorage.removeItem('isAdminLoggedIn');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-login">
            <h1>IMT Admin Login</h1>
            <form className="hms-stacked-form" onSubmit={handleSubmit}>
                {error && <div className="error">{error}</div>}
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <PasswordInput
                    wrapperClassName="admin-login-password-field"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button 
                    type="submit"
                    className={isLoading ? 'loading' : ''}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <span className="spinner"></span>
                            Logging in...
                        </>
                    ) : (
                        'Login'
                    )}
                </button>
            </form>
        </div>
    );
}

export default AdminLogin; 